import { PageController } from '$scripts/base-controller';

import {
  AdobeCreateAccountTrait,
  HasAdobeCreateAccountWithPopupOrRedirect,
} from '$traits/adobe-create-account';
import {
  AdobeSignInTrait,
  HasAdobeSignInWithPopupOrRedirect,
} from '$traits/adobe-sign-in';
import { GetOutcomesFromActions } from '$traits/helpers';
import { PasskeySignInTrait } from '$traits/passkey-sign-in';
import {
  HasSocialSignInWithPopupOrRedirect,
  SocialSignInTrait,
} from '$traits/social-sign-in';
import { getLoggers } from '$shared/loggers';
import { Provider, SocialProvider } from '$shared/types/social-provider';

import { PageState } from './state';

export type PageOutcome = GetOutcomesFromActions<
  [
    typeof AdobeSignInTrait.withPopupOrRedirect.action,
    typeof AdobeCreateAccountTrait.withPopupOrRedirect.action,
    typeof SocialSignInTrait.withPopupOrRedirect.action,
    typeof PasskeySignInTrait.withPopupOrRedirect.action
  ]
>;

export class Controller
  extends PageController<PageOutcome, PageState>
  implements
  HasSocialSignInWithPopupOrRedirect,
  HasAdobeSignInWithPopupOrRedirect,
  HasAdobeCreateAccountWithPopupOrRedirect {
  private static readonly logInfo = getLoggers().logInfo;

  private _onSignIn = AdobeSignInTrait.withPopupOrRedirect.action(this);
  onSignIn = (...args: Parameters<typeof this._onSignIn>) => {
    Controller.logInfo('[large-buttons-controller] Adobe Sign In action started');
    return this._onSignIn(...args);
  };

  private _onCreateAccount = AdobeCreateAccountTrait.withPopupOrRedirect.action(this);
  onCreateAccount = (...args: Parameters<typeof this._onCreateAccount>) => {
    Controller.logInfo('[large-buttons-controller] Adobe Create Account action started');
    return this._onCreateAccount(...args);
  };

  private _onSocialProviderSignInAction = SocialSignInTrait.withPopupOrRedirect.action(this);
  onSocialProviderSignIn = (provider: SocialProvider) => {
    Controller.logInfo('[large-buttons-controller] Social Sign In action started');
    return this._onSocialProviderSignInAction(provider);
  };

  private _onPasskeySignIn = PasskeySignInTrait.withPopupOrRedirect.action(this);
  onPasskeySignIn = (...args: Parameters<typeof this._onPasskeySignIn>) => {
    Controller.logInfo('[large-buttons-controller] Passkey Sign In action started');
    return this._onPasskeySignIn(...args);
  };

  toggleShowMoreProviders() {
    this.state.toggleShowMoreProviders();
  }
}
